<template>
  <div class="none404">
    <img :src="GetResourceUrl('Empty/404.png')" />

    <div>
      <div class="tip">{{l("您所寻找的页面不存在")}}</div>
      <!-- <div class="tip">该功能暂未开通，敬请期待</div> -->
      <div class="time">
        {{ countdown }} {{l("秒后自动")}}
        <span
          @click="goBack"
          style="cursor: pointer; text-decoration: underline"
        >
          <!-- {{ hasLast ? "返回上一页" : "返回首页" }} -->
          {{l("返回首页")}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "None404",
  data() {
    return {
      countdown: 5,
      timer: null,
      hasLast: true,
    };
  },
  mounted() {
    if (history.length > 1) {
      this.hasLast = true;
    } else {
      this.hasLast = false;
    }
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.goBack();
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    goBack() {
      clearInterval(this.timer);
      // if (this.hasLast) {
      //   this.$router.go(-1);
      // } else {
      this.$router.push("/home");
      // }
    },
  },
};
</script>
<style scoped lang="scss">
.none404 {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
  }
  .tip {
    font-size: 1.5rem;
  }
  .time {
    margin-top: 1rem;
    font-size: 1rem;
  }
}
</style>

